module.exports = __webpack_public_path__ + "static/media/user_icon.3a837725.svg";